import api from '../api'

export default {

  dashboard: async () => {
    return api.get(`api/pallets/dashboard`)
  },

  branches: async () => {
    return api.get('api/pallets/branches')
  },

  movementAllBranches: async () => {
    return api.get('api/pallets/movement-all-branches')
  },



  suppliers: async (has_pallets) => {
    return api.get('api/pallets/suppliers?has_pallets='+has_pallets)
  },

  pallets: async () => {
    return api.get('api/pallets')
  },

  adjustments: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/pallets/adjustments?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  movements: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/pallets/movements?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },


  createAdjustment: async adjustment => {
    return api.post('api/pallets/adjustments',adjustment)
  },

  adjustmentPrint: async(id) => {
    return api.get(`api/pallets/adjustments/${id}/print`,{
      headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType : 'blob'
    })
  },

  createMovement: async movement => {
    return api.post('api/pallets/movements', movement)
  },

  movement: async(id) => {
    return api.get(`api/pallets/movements/${id}`)
  },

  movementPrint: async(id) => {
    return api.get(`api/pallets/movements/${id}/print`,{
      headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType : 'blob'
    })
  },

  movementReceived: async movement => {
    return api.post('api/pallets/movements/'+movement.id+'/received', movement)
  },



  balanceSheetSupplierTransactions: async (from,to,id) => {
    return api.get(`api/pallets/balance-sheet/${from}/${to}/supplier-transactions/${id}`)
  },



  balanceSheetSupplierTransactionsPrint: async (from,to,id,branchId) => {
    return api.get(`api/pallets/balance-sheet/${from}/${to}/supplier-transactions/${id}/print?branch_id=${branchId}`,{
      headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType : 'blob'
    })
  },



  balanceSheetBranchTransactions: async (from,to,id) => {
    return api.get(`api/pallets/balance-sheet/${from}/${to}/branch-transactions/${id}`)
  },



  balanceSheetBranchTransactionsPrint: async (from,to,id) => {
    return api.get(`api/pallets/balance-sheet/${from}/${to}/branch-transactions/${id}/print`,{
      headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType : 'blob'
    })
  },


}
